export const portfolioSections = {
        // PART 1: PAINTINGS SECTION - IDs 1-26
        paintings: [
          {
            type: 'category',
            title: 'Dreamscapes',
            subtitle: '9 paintings',
            description: 'Work that draws from dreams, myths, and half-remembered stories.'
          },
          {
            type: 'artwork',
            id: 1,
            imagePath: 'Рыба.jpg',
            title: "Рыба",
            year: "2009",
            medium: "Oil on canvas",
            dimensions: "24 × 36 in",
            layout: "landscape"
          },
          {
            type: 'artwork',
            id: 2,
            imagePath: 'Рыба 2.jpg',
            title: "Рыба II",
            year: "2010",
            medium: "Oil on canvas",
            dimensions: "14 × 18 in",
            layout: "offset-right"
          },
          {
            type: 'artwork',
            id: 3,
            imagePath: 'Рыба3.jpg',
            title: "Рыба (Study)",
            year: "2009",
            medium: "Oil on canvas",
            dimensions: "24 × 36 in",
            layout: "offset-right"
          },
          {
            type: 'artwork',
            id: 4,
            imagePath: 'Город.jpg',
            title: "Город",
            year: "2024",
            medium: "Oil on canvas",
            dimensions: "20 × 24 in",
            layout: "landscape"
          },
          {
            type: 'artwork',
            id: 5,
            imagePath: 'blue_2020.jpg',
            title: "Blue 2020",
            year: "2020",
            medium: "Acrylic on canvas",
            dimensions: "20 × 24 in",
            layout: "landscape"
          },
          {
            type: 'artwork',
            id: 6,
            imagePath: 'Сон.jpg',
            title: "Сон",
            year: "2007",
            medium: "Oil on canvas",
            dimensions: "36 × 36 in",
            layout: "landscape"
          },
          {
            type: 'artwork',
            id: 7,
            imagePath: '2020_November_two.jpg',
            title: "November II",
            year: "2020",
            medium: "Oil on canvas",
            dimensions: "10 × 8 in",
            layout: "offset-left"
          },
          {
            type: 'artwork',
            id: 8,
            imagePath: 'Transition.jpg',
            title: "Transition",
            year: "1997",
            medium: "Acrylic on canvas",
            dimensions: "24 × 48 in",
            layout: "landscape"
          },
          {
            type: 'artwork',
            id: 9,
            imagePath: 'без названия.jpg',
            title: "Без названия",
            year: "2009",
            medium: "Acrylic on canvas",
            dimensions: "24 × 36 in",
            layout: "offset-right"
          },
          {
            type: 'artwork',
            id: 10,
            imagePath: '2020_November.jpg',
            title: "November",
            year: "2020",
            medium: "Oil on canvas",
            dimensions: "16 × 20 in",
            layout: "default"
          },
        
          {
            type: 'category',
            title: 'Landscapes',
            subtitle: '6 paintings',
            description: 'Places painted from sketches, photos, and imperfect memory.'
          },
          {
            type: 'artwork',
            id: 11,
            imagePath: 'Yellowstone.jpg',
            title: "Yellowstone",
            year: "2010",
            medium: "Oil on canvas",
            dimensions: "24 × 36 in",
            layout: "landscape"
          },
          {
            type: 'artwork',
            id: 12,
            imagePath: 'California1.jpg',
            title: "California II",
            year: "2021",
            medium: "Oil on canvas",
            dimensions: "24 × 36 in",
            layout: "default"
          },
          {
            type: 'artwork',
            id: 13,
            imagePath: 'California2.jpg',
            title: "California I",
            year: "2021",
            medium: "Oil on canvas",
            dimensions: "24 × 36 in",
            layout: "offset-right"
          },
          {
            type: 'artwork',
            id: 14,
            imagePath: 'Rotorua.jpg',
            title: "Rotorua",
            year: "2008",
            medium: "Oil on canvas",
            dimensions: "36 × 36 in",
            layout: "landscape"
          },
          {
            type: 'artwork',
            id: 15,
            imagePath: 'Tartu.jpg',
            title: "Tartu",
            year: "2008",
            medium: "Oil on canvas",
            dimensions: "24 x 48 in",
            layout: "landscape"
          },
          {
            type: 'artwork',
            id: 16,
            imagePath: 'детство.jpg',
            title: "Детство",
            year: "2009",
            medium: "Oil on canvas",
            dimensions: "36 × 18 in",
            layout: "offset-left"
          },
        
          {
            type: 'category',
            title: 'Portraits & Figures',
            subtitle: '6 paintings',
            description: 'People I have painted over the years - friends, family, and faces that stayed with me.'
          },
          {
            type: 'artwork',
            id: 17,
            imagePath: 'Thea.jpg',
            title: "Thea",
            year: "2019",
            medium: "Oil on canvas",
            dimensions: "18 × 24 in",
            layout: "default"
          },
          {
            type: 'artwork',
            id: 18,
            imagePath: 'Berta_2023.jpg',
            title: "Berta",
            year: "2022",
            medium: "Acrylic on canvas",
            dimensions: "36 × 24 in",
            layout: "default"
          },
          {
            type: 'artwork',
            id: 19,
            imagePath: 'Лиса Ах.ли.jpg',
            title: "Лиса Ахули",
            year: "2009",
            medium: "Oil on canvas",
            dimensions: "30 × 24 in",
            layout: "offset-right"
          },
          {
            type: 'artwork',
            id: 20,
            imagePath: 'woman_in_yellow_hat.jpg',
            title: "Woman in Yellow Hat",
            year: "2022",
            medium: "Acrylic on board",
            dimensions: "11 × 14 in",
            layout: "default"
          },
          {
            type: 'artwork',
            id: 21,
            imagePath: 'Georgia_2006.jpg',
            title: "Georgia",
            year: "2006",
            medium: "Acrylic on board",
            dimensions: "10 × 8 in",
            layout: "offset-left"
          },
          {
            type: 'artwork',
            id: 22,
            imagePath: 'Two_2006.jpg',
            title: "Two",
            year: "2005",
            medium: "Acrylic on canvas",
            dimensions: "10 × 8 in",
            layout: "default"
          },
        
          {
            type: 'category',
            title: 'Still Life & Arrangements',
            subtitle: '4 paintings',
            description: 'objects, light, and domestic beauty'
          },
          {
            type: 'artwork',
            id: 23,
            imagePath: 'Прованс.jpg',
            title: "Прованс",
            year: "2009",
            medium: "Oil on canvas",
            dimensions: "36 × 24 in",
            layout: "landscape"
          },
          {
            type: 'artwork',
            id: 24,
            imagePath: 'натюрморт  1.jpg',
            title: "Натюрморт",
            year: "2009",
            medium: "Oil on canvas",
            dimensions: "36 × 36 in",
            layout: "default"
          },
          {
            type: 'artwork',
            id: 25,
            imagePath: 'натюрморт 2.jpg',
            title: "Silver Pitcher",
            year: "2012",
            medium: "Oil on canvas",
            dimensions: "16 × 20 in",
            layout: "offset-right"
          },
          {
            type: 'artwork',
            id: 26,
            imagePath: 'Сирень.jpg',
            title: "Сирень",
            year: "2011",
            medium: "Oil on canvas",
            dimensions: "12 × 16 in",
            layout: "default"
          }
        ],
          // PART 2: SCULPTURES SECTION - IDs 100-250
        sculpture: [
          {
            type: 'category',
            title: 'Holding Steady',
            subtitle: '1 sculpture, Multiple views',
            description: 'Cube of Self-Support'
          },
          {
            type: 'artwork',
            id: 208,
            imagePath: 'HoldingSteady1.jpg',
            title: "Holding Steady (view 1)",
            year: "2026",
            medium: "Stoneware",
            dimensions: '12 x 12 x 12 inches'
          },
          {
            type: 'artwork',
            id: 209,
            imagePath: 'HoldingSteady2.jpg',
            title: "Holding Steady (view 2)",
            year: "2026",
            medium: "Stoneware",
            dimensions: '12 x 12 x 12 inches'
          },
           {
            type: 'artwork',
            id: 210,
            imagePath: 'HoldingSteady3.jpg',
            title: "Holding Steady (view 3)",
            year: "2026",
            medium: "Stoneware",
            dimensions: '12 x 12 x 12 inches'
          },
           {
            type: 'artwork',
            id: 211,
            imagePath: 'HoldingSteady4.jpg',
            title: "Holding Steady (view 4)",
            year: "2026",
            medium: "Stoneware",
            dimensions: '12 x 12 x 12 inches'
          },
           {
            type: 'artwork',
            id: 212,
            imagePath: 'HoldingSteady5.jpg',
            title: "Holding Steady (view 5)",
            year: "2026",
            medium: "Stoneware",
            dimensions: '12 x 12 x 12 inches'
          },
          {
            type: 'category',
            title: 'Protect',
            subtitle: '1 sculpture, Multiple views',
            description: ''
          },
          {
            type: 'artwork',
            id: 216,
            imagePath: 'Protect_1.jpg',
            title: "Protect (view 1)",
            year: "2026",
            medium: "Stoneware",
            dimensions: '23" H'
          },
          {
            type: 'artwork',
            id: 217,
            imagePath: 'Protect_2.jpg',
            title: "Protect (view 2)",
            year: "2026",
            medium: "Stoneware",
            dimensions: '23" H'
          },
          {
            type: 'artwork',
            id: 218,
            imagePath: 'Protect_3.jpg',
            title: "Protect (view 3)",
            year: "2026",
            medium: "Stoneware",
            dimensions: '23" H'
          },
          {
            type: 'artwork',
            id: 219,
            imagePath: 'Protect_4.jpg',
            title: "Protect (view 4)",
            year: "2026",
            medium: "Stoneware",
            dimensions: '23" H'
          },
          {
            type: 'category',
            title: 'Horse',
            subtitle: '1 sculpture, Multiple views',
            description: ''
          },
          {
            type: 'artwork',
            id: 224,
            imagePath: 'horse_1.jpg',
            title: "Horse (view 1)",
            year: "2025",
            medium: "Stoneware",
            dimensions: '8" H'
          },
          {
            type: 'artwork',
            id: 225,
            imagePath: 'horse_2.jpg',
            title: "Horse (view 2)",
            year: "2025",
            medium: "Stoneware",
            dimensions: '8" H'
          },
          {
            type: 'artwork',
            id: 226,
            imagePath: 'horse_3.jpg',
            title: "Horse (view 3)",
            year: "2025",
            medium: "Stoneware",
            dimensions: '8" H'
          },
          {
            type: 'artwork',
            id: 227,
            imagePath: 'horse_4.jpg',
            title: "Horse (view 4)",
            year: "2025",
            medium: "Stoneware",
            dimensions: '8" H'
          },
          {
            type: 'artwork',
            id: 228,
            imagePath: 'horse_5.jpg',
            title: "Horse (view 5)",
            year: "2025",
            medium: "Stoneware",
            dimensions: '8" H'
          },
           {
            type: 'artwork',
            id: 231,
            imagePath: 'horse_8.jpg',
            title: "Horse (view 6)",
            year: "2025",
            medium: "Stoneware",
            dimensions: '8" H'
          },
          {
            type: 'artwork',
            id: 230,
            imagePath: 'horse_7.jpg',
            title: "Horse (view 7)",
            year: "2025",
            medium: "Stoneware",
            dimensions: '8" H'
          },
          {
            type: 'artwork',
            id: 229,
            imagePath: 'horse_6.jpg',
            title: "Horse (view 8)",
            year: "2025",
            medium: "Stoneware",
            dimensions: '8" H'
          },
         
          {
            type: 'category',
            title: 'Dove',
            subtitle: '1 sculpture, Multiple views',
            description: 'A bird can just be a bird.'
          },
          {
            type: 'artwork',
            id: 220,
            imagePath: 'bird_1.png',
            title: "Dove (view 1)",
            year: "2025",
            medium: "Stoneware",
            dimensions: '6" H'
          },
          {
            type: 'artwork',
            id: 221,
            imagePath: 'bird_2.png',
            title: "Dove (view 2)",
            year: "2025",
            medium: "Stoneware",
            dimensions: '6" H'
          },
          {
            type: 'artwork',
            id: 222,
            imagePath: 'bird_3.png',
            title: "Dove (view 3)",
            year: "2025",
            medium: "Stoneware",
            dimensions: '6" H'
          },
          {
            type: 'artwork',
            id: 223,
            imagePath: 'bird_4.png',
            title: "Dove (view 4)",
            year: "2025",
            medium: "Stoneware",
            dimensions: '6" H'
          },
          {
            type: 'category',
            title: 'Conversation',
            subtitle: '1 sculpture, Multiple views',
            description: 'These critters are in conversation. Can you see them?'
          },
          {
            type: 'artwork',
            id: 343,
            imagePath: 'conversation_1.jpg',
            title: "Conversation (view 1)",
            year: "2026",
            medium: "Stoneware, porcelain",
            dimensions: '14"'
          },
          {
            type: 'artwork',
            id: 344,
            imagePath: 'conversation_2.jpg',
            title: "Conversation (view 2)",
            year: "2026",
            medium: "Stoneware, porcelain",
            dimensions: '14"'
          },
          {
            type: 'artwork',
            id: 345,
            imagePath: 'conversation_3.jpg',
            title: "Conversation (view 3)",
            year: "2026",
            medium: "Stoneware, porcelain",
            dimensions: '14"'
          },
          {
            type: 'artwork',
            id: 346,
            imagePath: 'conversation_4.jpg',
            title: "Conversation (view 4)",
            year: "2026",
            medium: "Stoneware, porcelain",
            dimensions: '14"'
          },
          {
            type: 'category',
            title: 'Two',
            subtitle: '1 sculpture, Multiple views',
            description: ''
          },
          {
            type: 'artwork',
            id: 347,
            imagePath: 'two_1.jpg',
            title: "Two (view 1)",
            year: "2026",
            medium: "Stoneware, porcelain",
            dimensions: '12"'
          },
           {
            type: 'artwork',
            id: 348,
            imagePath: 'two_2.jpg',
            title: "Two (view 2)",
            year: "2026",
            medium: "Stoneware, porcelain",
            dimensions: '12"'
          },
          {
            type: 'artwork',
            id: 349,
            imagePath: 'two_3.jpg',
            title: "Two (view 3)",
            year: "2026",
            medium: "Stoneware, porcelain",
            dimensions: '12"'
          },
          {
            type: 'category',
            title: 'Snake',
            subtitle: '1 sculpture, Multiple views',
            description: ''
          },
          {
            type: 'artwork',
            id: 232,
            imagePath: 'snake_1.jpg',
            title: "Snake (view 1)",
            year: "2025",
            medium: "Stoneware",
            dimensions: '9" L'
          },
          {
            type: 'artwork',
            id: 233,
            imagePath: 'snake_2.jpg',
            title: "Snake (view 2)",
            year: "2025",
            medium: "Stoneware",
            dimensions: '9" L'
          },
          {
            type: 'artwork',
            id: 234,
            imagePath: 'snake_3.jpg',
            title: "Snake (view 3)",
            year: "2025",
            medium: "Stoneware",
            dimensions: '9" L'
          },
          {
            type: 'artwork',
            id: 235,
            imagePath: 'snake_4.jpg',
            title: "Snake (view 4)",
            year: "2025",
            medium: "Stoneware",
            dimensions: '9" L'
          },
           {
            type: 'category',
            title: "Let's breeze",
            subtitle: '1 sculpture, Multiple views',
            description: ''
          },
          {
            type: 'artwork',
            id: 236,
            imagePath: 'not_a_face1.jpg',
            title: "Let's breeze (view 1)",
            year: "2026",
            medium: "Stoneware",
            dimensions: '16" L'
          },
          {
            type: 'artwork',
            id: 237,
            imagePath: 'not_a_face5.jpg',
            title: "Let's breeze (view 2)",
            year: "2026",
            medium: "Stoneware",
            dimensions: '16" L'
          },
          {
            type: 'artwork',
            id: 238,
            imagePath: 'not_a_face6.jpg',
            title: "Let's breeze (view 3)",
            year: "2026",
            medium: "Stoneware",
            dimensions: '16" L'
          },
          {
            type: 'artwork',
            id: 239,
            imagePath: 'not_a_face7.jpg',
            title: "Let's breeze (view 4)",
            year: "2026",
            medium: "Stoneware",
            dimensions: '16" L'
          },
          {
            type: 'category',
            title: 'Steampunk',
            subtitle: '1 sculpture, Multiple views',
            description: 'At peace with her wiring.'
          },
          {
            type: 'artwork',
            id: 100,
            imagePath: 'Steampunk_1.2.jpg',
            title: "Steampunk (view 1)",
            year: "2012",
            medium: "Stoneware",
            dimensions: "13 × 9 × 10 in"
          },
          {
            type: 'artwork',
            id: 101,
            imagePath: 'Steampunk_1.6.jpg',
            title: "Steampunk (view 2)",
            year: "2012",
            medium: "Stoneware",
            dimensions: "13 × 9 × 10 in"
          },
          {
            type: 'artwork',
            id: 102,
            imagePath: 'Steampunk_1.7.jpg',
            title: "Steampunk (view 3)",
            year: "2012",
            medium: "Stoneware",
            dimensions: "13 × 9 × 10 in"
          },
          {
            type: 'artwork',
            id: 103,
            imagePath: 'Steampunk_1.4.jpg',
            title: "Steampunk (view 4)",
            year: "2012",
            medium: "Stoneware",
            dimensions: "13 × 9 × 10 in"
          },
          {
            type: 'artwork',
            id: 213,
            imagePath: 'Steampunk_1.8.jpg',
            title: "Steampunk (view 1, glazed)",
            year: "2025",
            medium: "Stoneware",
            dimensions: "13 × 9 × 10 in"
          },
          {
            type: 'artwork',
            id: 214,
            imagePath: 'Steampunk_1.9.jpg',
            title: "Steampunk (view 2, glazed)",
            year: "2025",
            medium: "Stoneware",
            dimensions: "13 × 9 × 10 in"
          },
          {
            type: 'artwork',
            id: 215,
            imagePath: 'Steampunk_1.10.jpg',
            title: "Steampunk (view 3, glazed)",
            year: "2025",
            medium: "Stoneware",
            dimensions: "13 × 9 × 10 in"
          },
          {
            type: 'category',
            title: 'Head Study (Gazing Down)',
            subtitle: '1 sculpture, , Multiple views',
            description: 'Dreaming through the breakdown.'
          },
          {
            type: 'artwork',
            id: 104,
            imagePath: 'headshot2.jpg',
            title: "Head Study (Gazing Down) - view 1",
            year: "2013",
            medium: "Stoneware (Unfired)",
            dimensions: "10 in tall"
          },
          {
            type: 'artwork',
            id: 105,
            imagePath: 'headshot1.jpg',
            title: "Head Study (Gazing Down) - view 2",
            year: "2013",
            medium: "Stoneware (Unfired)",
            dimensions: "10 in tall"
          },
          {
            type: 'artwork',
            id: 106,
            imagePath: 'headshot3.jpg',
            title: "Head Study (Gazing Down) - view 3",
            year: "2013",
            medium: "Stoneware",
            dimensions: "10 in tall"
          },
          {
            type: 'artwork',
            id: 107,
            imagePath: 'COVER.jpg',
            title: "Head Study (Gazing Down) - view 4",
            year: "2013",
            medium: "Stoneware",
            dimensions: "10 in tall"
          },
          {
            type: 'artwork',
            id: 108,
            imagePath: 'COVER2.jpg',
            title: "Head Study (Gazing Down) - view 5",
            year: "2013",
            medium: "Stoneware",
            dimensions: "10 in tall"
          },
        
          {
            type: 'category',
            title: 'Head Study II',
            subtitle: '1 sculpture, Multiple views',
            description: 'Portrait study in stoneware'
          },
          {
            type: 'artwork',
            id: 109,
            imagePath: 'headstudy1.jpg',
            title: "Head Study II - view 1",
            year: "2013",
            medium: "Stoneware",
            dimensions: "11 in tall"
          },
          {
            type: 'artwork',
            id: 110,
            imagePath: 'headstudy2.jpg',
            title: "Head Study II - view 2",
            year: "2013",
            medium: "Stoneware",
            dimensions: "11 in tall"
          },
          {
            type: 'artwork',
            id: 111,
            imagePath: 'headstudy3.jpg',
            title: "Head Study II - view 3",
            year: "2013",
            medium: "Stoneware",
            dimensions: "11 in tall"
          },
          {
            type: 'artwork',
            id: 112,
            imagePath: 'headstudy4.jpg',
            title: "Head Study II - view 4",
            year: "2013",
            medium: "Stoneware",
            dimensions: "11 in tall"
          },
        
          {
            type: 'category',
            title: 'Гамаючик',
            subtitle: '1 sculpture, Multiple views',
            description: 'Little creature who remembers all the old stories.'
          },
          {
            type: 'artwork',
            id: 113,
            imagePath: 'PXL_20210307.PORTRAIT.jpg',
            title: "Гамаючик (view 1)",
            year: "2020",
            medium: "Porcelain",
            dimensions: "3 × 2 × 2 in"
          },
          {
            type: 'artwork',
            id: 114,
            imagePath: 'Гамаюн.jpg',
            title: "Гамаючик (view 2)",
            year: "2020",
            medium: "Porcelain",
            dimensions: "3 × 2 × 2 in"
          },
          {
            type: 'artwork',
            id: 115,
            imagePath: 'Гамаюн2.jpg',
            title: "Гамаючик (view 3)",
            year: "2020",
            medium: "Porcelain",
            dimensions: "3 × 2 × 2 in"
          },
        
          {
            type: 'category',
            title: 'Tits Up',
            subtitle: '1 sculpture, Multiple views',
            description: 'This is vulnerability - standing tall despite being broken open, embracing the empty spaces that make us lighter.'
          },
          {
            type: 'artwork',
            id: 116,
            imagePath: 'Tits_Up1.jpg',
            title: "Tits Up",
            year: "2024",
            medium: "Porcelain",
            dimensions: '6" tall'
          },
          {
            type: 'artwork',
            id: 117,
            imagePath: 'Tits_Up2.jpg',
            title: "Tits Up",
            year: "2024",
            medium: "Porcelain",
            dimensions: '6" tall'
          },
          {
            type: 'artwork',
            id: 118,
            imagePath: 'Tits_Up3.jpg',
            title: "Tits Up",
            year: "2024",
            medium: "Porcelain",
            dimensions: '6" tall'
          },
          {
            type: 'artwork',
            id: 119,
            imagePath: 'Tits_Up4.jpg',
            title: "Tits Up",
            year: "2024",
            medium: "Porcelain",
            dimensions: '6" tall'
          },
          {
            type: 'artwork',
            id: 120,
            imagePath: 'Tits_Up5.jpg',
            title: "Tits Up",
            year: "2024",
            medium: "Porcelain",
            dimensions: '6" tall'
          },
        
          {
            type: 'category',
            title: 'Nestled Thoughts',
            subtitle: '1 sculpture, Multiple views',
            description: 'Nestled Thoughts - when whispers need a keeper to hold them safely until they are ready to be heard.'
          },
        
          {
            type: 'artwork',
            id: 121,
            imagePath: 'Nestled_Thoughts1.jpg',
            title: "Nestled Thoughts",
            year: "2021",
            medium: "Porcelain",
            dimensions: '2" tall'
          },
          {
            type: 'artwork',
            id: 122,
            imagePath: 'Nestled_Thoughts.mp4',
            mediaType: 'video',
            title: "Nestled Thoughts",
            year: "2021",
            medium: "Porcelain",
            dimensions: '2" tall'
          },
          {
            type: 'category',
            title: 'Reflection',
            subtitle: '1 sculpture, Multiple views',
            description: 'Reflection - trying to figure out what to carry and what to leave behind.'
          },
          {
            type: 'artwork',
            id: 123,
            imagePath: 'Man1.mp4',
            mediaType: 'video',
            title: "Reflection",
            year: "2020",
            medium: "Porcelain",
            dimensions: '2.5" tall'
          },
          {
            type: 'artwork',
            id: 124,
            imagePath: 'Man1.jpg',
            title: "Reflection",
            year: "2020",
            medium: "Porcelain",
            dimensions: '2.5" tall'
          },
          {
            type: 'artwork',
            id: 125,
            imagePath: 'Man2.jpg',
            title: "Reflection",
            year: "2020",
            medium: "Porcelain",
            dimensions: '2.5" tall'
          },
        
          {
            type: 'category',
            title: 'Scaling Life',
            subtitle: '1 sculpture, Multiple views',
            description: 'This is us - scaling life, tiptoeing on the edge, pulling each other up, stoneware, 5 in tall'
          },
          {
            type: 'artwork',
            id: 126,
            imagePath: 'ScalingLife1.jpg',
            title: "Scaling Life",
            year: "2024",
            medium: "Porcelain",
            dimensions: '6" tall'
          },
          {
            type: 'artwork',
            id: 127,
            imagePath: 'ScalingLife2.jpg',
            title: "Scaling Life",
            year: "2024",
            medium: "Porcelain",
            dimensions: '6" tall'
          },
          {
            type: 'artwork',
            id: 128,
            imagePath: 'ScalingLife3.jpg',
            title: "Scaling Life",
            year: "2024",
            medium: "Porcelain",
            dimensions: '6" tall'
          },
          {
            type: 'artwork',
            id: 129,
            imagePath: 'ScalingLife4.jpg',
            title: "Scaling Life",
            year: "2024",
            medium: "Porcelain",
            dimensions: '6" tall'
          },
          {
            type: 'artwork',
            id: 130,
            imagePath: 'ScalingLife5.jpg',
            title: "Scaling Life",
            year: "2024",
            medium: "Porcelain",
            dimensions: '6" tall'
          },
          {
            type: 'artwork',
            id: 131,
            imagePath: 'ScalingLife6.jpg',
            title: "Scaling Life",
            year: "2024",
            medium: "Porcelain",
            dimensions: '6" tall'
          },
          {
            type: 'artwork',
            id: 132,
            imagePath: 'ScalingLife7.jpg',
            title: "Scaling Life",
            year: "2024",
            medium: "Porcelain",
            dimensions: '6" tall'
          },
        
          {
            type: 'category',
            title: 'The Inhabitants',
            subtitle: '1 sculpture, Multiple views',
            description: 'The Inhabitants - testing how small-scale narrative elements work against large organic forms. Multiple firings to build up the surface colors.'
          },
          {
            type: 'artwork',
            id: 133,
            imagePath: 'FishStory1.jpg',
            title: "The Inhabitants",
            year: "2024",
            medium: "Porcelain",
            dimensions: '7" long'
          },
          {
            type: 'artwork',
            id: 134,
            imagePath: 'FishStory2.jpg',
            title: "The Inhabitants",
            year: "2024",
            medium: "Porcelain",
            dimensions: '7" long'
          },
          {
            type: 'artwork',
            id: 135,
            imagePath: 'FishStory3.jpg',
            title: "The Inhabitants",
            year: "2024",
            medium: "Porcelain",
            dimensions: '7" long'
          },
          {
            type: 'artwork',
            id: 136,
            imagePath: 'FishStory4.jpg',
            title: "The Inhabitants",
            year: "2024",
            medium: "Porcelain",
            dimensions: '7" long'
          },
          {
            type: 'artwork',
            id: 137,
            imagePath: 'FishStory5.jpg',
            title: "The Inhabitants",
            year: "2024",
            medium: "Porcelain",
            dimensions: '7" long'
          },
        
          {
            type: 'category',
            title: 'Story Keeper',
            subtitle: '1 sculpture, Multiple views',
            description: 'Story Keeper - Sometimes we carry entire worlds within us ...'
          },
          {
            type: 'artwork',
            id: 138,
            imagePath: 'StoryKeeper1.jpg',
            title: "Story Keeper",
            year: "2021",
            medium: "Porcelain",
            dimensions: '4.5" tall'
          },
          {
            type: 'artwork',
            id: 139,
            imagePath: 'StoryKeeper2.jpg',
            title: "Story Keeper",
            year: "2021",
            medium: "Porcelain",
            dimensions: '4.5" tall'
          },
          {
            type: 'artwork',
            id: 140,
            imagePath: 'StoryKeeper3.jpg',
            title: "Story Keeper",
            year: "2021",
            medium: "Porcelain",
            dimensions: '4.5" tall'
          },
          {
            type: 'artwork',
            id: 141,
            imagePath: 'StoryKeeper4.jpg',
            title: "Story Keeper",
            year: "2021",
            medium: "Porcelain",
            dimensions: '4.5" tall'
          },
          {
            type: 'artwork',
            id: 142,
            imagePath: 'StoryKeeper5.jpg',
            title: "Story Keeper",
            year: "2021",
            medium: "Porcelain",
            dimensions: '4.5" tall'
          },
          {
            type: 'artwork',
            id: 143,
            imagePath: 'StoryKeeper6.jpg',
            title: "Story Keeper",
            year: "2021",
            medium: "Porcelain",
            dimensions: '4.5" tall'
          },
        
          {
            type: 'category',
            title: 'Emergence',
            subtitle: '1 sculpture, Multiple views',
            description: 'Emergence - for a breath of fresh air.'
          },
          {
            type: 'artwork',
            id: 144,
            imagePath: 'Emergence1.jpg',
            title: "Emergence",
            year: "2021",
            medium: "Porcelain",
            dimensions: '6.5" tall'
          },
          {
            type: 'artwork',
            id: 145,
            imagePath: 'Emergence2.jpg',
            title: "Emergence",
            year: "2021",
            medium: "Porcelain",
            dimensions: '6.5" tall'
          },
          {
            type: 'artwork',
            id: 146,
            imagePath: 'Emergence3.jpg',
            title: "Emergence",
            year: "2021",
            medium: "Porcelain",
            dimensions: '6.5" tall'
          },
          {
            type: 'artwork',
            id: 147,
            imagePath: 'Emergence4.jpg',
            title: "Emergence",
            year: "2021",
            medium: "Porcelain",
            dimensions: '6.5" tall'
          },
          {
            type: 'artwork',
            id: 148,
            imagePath: 'Emergence5.jpg',
            title: "Emergence",
            year: "2021",
            medium: "Porcelain",
            dimensions: '6.5" tall'
          },
          {
            type: 'artwork',
            id: 149,
            imagePath: 'Emergence6.jpg',
            title: "Emergence",
            year: "2021",
            medium: "Porcelain",
            dimensions: '6.5" tall'
          },
          {
            type: 'artwork',
            id: 150,
            imagePath: 'Emergence7.jpg',
            title: "Emergence",
            year: "2021",
            medium: "Porcelain",
            dimensions: '6.5" tall'
          },
          {
            type: 'category',
            title: 'Two-faced',
            subtitle: '1 sculpture, Multiple views',
            description: "Hidden Self - the part we don't talk about."
          },
          {
            type: 'artwork',
            id: 184,
            imagePath: 'Two-faced7.jpg',
            title: "Two-faced",
            year: "2025",
            medium: "Stoneware",
            dimensions: '4.5" tall'
          },
          {
            type: 'artwork',
            id: 185,
            imagePath: 'Two-faced8.jpg',
            title: "Two-faced",
            year: "2025",
            medium: "Stoneware",
            dimensions: '4.5" tall'
          },
          {
            type: 'artwork',
            id: 186,
            imagePath: 'Two-faced6.jpg',
            title: "Two-faced",
            year: "2025",
            medium: "Stoneware",
            dimensions: '4.5" tall'
          },
          {
            type: 'artwork',
            id: 187,
            imagePath: 'Two-faced9.jpg',
            title: "Two-faced",
            year: "2025",
            medium: "Stoneware",
            dimensions: '4.5" tall'
          },
          {
            type: 'artwork',
            id: 188,
            imagePath: 'Two-faced1.jpg',
            title: "Two-faced",
            year: "2025",
            medium: "Stoneware",
            dimensions: '4.5" tall'
          },
          {
            type: 'artwork',
            id: 189,
            imagePath: 'Two-faced2.jpg',
            title: "Two-faced",
            year: "2025",
            medium: "Stoneware",
            dimensions: '4.5" tall'
          },
          {
            type: 'artwork',
            id: 190,
            imagePath: 'Two-faced3.jpg',
            title: "Two-faced",
            year: "2025",
            medium: "Stoneware",
            dimensions: '4.5" tall'
          },
          {
            type: 'artwork',
            id: 191,
            imagePath: 'Two-faced4.jpg',
            title: "Two-faced",
            year: "2025",
            medium: "Stoneware",
            dimensions: '4.5" tall'
          },
          {
            type: 'artwork',
            id: 192,
            imagePath: 'Two-faced5.jpg',
            title: "Two-faced",
            year: "2025",
            medium: "Stoneware",
            dimensions: '4.5" tall'
          },
          {
            type: 'category',
            title: 'Myth',
            subtitle: '1 sculpture, Multiple views',
            description: "Everything Everywhere All at Once"
          },
          {
            type: 'artwork',
            id: 193,
            imagePath: 'Myth1.jpg',
            title: "Myth",
            year: "2025",
            medium: "Stoneware",
            dimensions: '8" tall'
          },
          {
            type: 'artwork',
            id: 194,
            imagePath: 'Myth2.jpg',
            title: "Myth",
            year: "2025",
            medium: "Stoneware",
            dimensions: '8" tall'
          },
          {
            type: 'artwork',
            id: 195,
            imagePath: 'Myth3.jpg',
            title: "Myth",
            year: "2025",
            medium: "Stoneware",
            dimensions: '8" tall'
          },
          {
            type: 'artwork',
            id: 196,
            imagePath: 'Myth4.jpg',
            title: "Myth",
            year: "2025",
            medium: "Stoneware",
            dimensions: '8" tall'
          },
          {
            type: 'artwork',
            id: 197,
            imagePath: 'Myth7.jpg',
            title: "Myth",
            year: "2025",
            medium: "Stoneware",
            dimensions: '8" tall'
          },
          {
            type: 'artwork',
            id: 198,
            imagePath: 'Myth5.jpg',
            title: "Myth",
            year: "2025",
            medium: "Stoneware",
            dimensions: '8" tall'
          },
          {
            type: 'artwork',
            id: 199,
            imagePath: 'Myth6.jpg',
            title: "Myth",
            year: "2025",
            medium: "Stoneware",
            dimensions: '8" tall'
          },
          {
            type: 'category',
            title: 'Split',
            subtitle: '1 sculpture, Multiple views',
            description: "Split - weary mind, panicked gut."
          },
          {
            type: 'artwork',
            id: 200,
            imagePath: 'Split1.jpg',
            title: "Split",
            year: "2025",
            medium: "Stoneware",
            dimensions: '6" tall'
          },
          {
            type: 'artwork',
            id: 201,
            imagePath: 'Split2.jpg',
            title: "Split",
            year: "2025",
            medium: "Stoneware",
            dimensions: '6" tall'
          },
          {
            type: 'artwork',
            id: 202,
            imagePath: 'Split3.jpg',
            title: "Split",
            year: "2025",
            medium: "Stoneware",
            dimensions: '6" tall'
          },
          {
            type: 'artwork',
            id: 203,
            imagePath: 'Split4.jpg',
            title: "Split",
            year: "2025",
            medium: "Stoneware",
            dimensions: '6" tall'
          },
          {
            type: 'artwork',
            id: 204,
            imagePath: 'Split6.jpg',
            title: "Split",
            year: "2025",
            medium: "Stoneware",
            dimensions: '6" tall'
          },
          {
            type: 'artwork',
            id: 205,
            imagePath: 'Split7.jpg',
            title: "Split",
            year: "2025",
            medium: "Stoneware",
            dimensions: '6" tall'
          },
          {
            type: 'artwork',
            id: 206,
            imagePath: 'Split8.jpg',
            title: "Split",
            year: "2025",
            medium: "Stoneware",
            dimensions: '6" tall'
          },
          {
            type: 'artwork',
            id: 207,
            imagePath: 'Split9.jpg',
            title: "Split",
            year: "2025",
            medium: "Stoneware",
            dimensions: '6" tall'
          },
          {
            type: 'category',
            title: 'Voice',
            subtitle: '1 sculpture, Multiple views',
            description: 'Voice - scream into the void.'
          },
          {
            type: 'artwork',
            id: 151,
            imagePath: 'Voice1.jpg',
            title: "Voice",
            year: "2021",
            medium: "Porcelain",
            dimensions: '2.5" tall'
          },
          {
            type: 'artwork',
            id: 152,
            imagePath: 'Voice2.jpg',
            title: "Voice",
            year: "2021",
            medium: "Porcelain",
            dimensions: '2.5" tall'
          },
          {
            type: 'artwork',
            id: 153,
            imagePath: 'Voice3.jpg',
            title: "Voice",
            year: "2021",
            medium: "Porcelain",
            dimensions: '2.5" tall'
          },
          {
            type: 'artwork',
            id: 154,
            imagePath: 'Voice4.jpg',
            title: "Voice",
            year: "2021",
            medium: "Porcelain",
            dimensions: '2.5" tall'
          },
          {
            type: 'artwork',
            id: 155,
            imagePath: 'Voice5.jpg',
            title: "Voice",
            year: "2021",
            medium: "Porcelain",
            dimensions: '2.5" tall'
          },
          {
            type: 'artwork',
            id: 156,
            imagePath: 'Voice6.jpg',
            title: "Voice",
            year: "2021",
            medium: "Porcelain",
            dimensions: '2.5" tall'
          },
          {
            type: 'artwork',
            id: 157,
            imagePath: 'Voice7.jpg',
            title: "Voice",
            year: "2021",
            medium: "Porcelain",
            dimensions: '2.5" tall'
          },
        
          {
            type: 'category',
            title: 'Rest',
            subtitle: '1 sculpture, Multiple views',
            description: 'Frame of reference'
          },
          {
            type: 'artwork',
            id: 158,
            imagePath: 'Girl1.jpg',
            title: "Rest",
            year: "2021 - 2025",
            medium: "Porcelain",
            dimensions: '4" long'
          },
          {
            type: 'artwork',
            id: 159,
            imagePath: 'Girl2.jpg',
            title: "Rest",
            year: "2025",
            medium: "Porcelain",
            dimensions: '4" long'
          },
          {
            type: 'artwork',
            id: 160,
            imagePath: 'Girl3.jpg',
            title: "Rest",
            year: "2025",
            medium: "Porcelain",
            dimensions: '4" long'
          },
          {
            type: 'artwork',
            id: 161,
            imagePath: 'Girl4.jpg',
            title: "Rest",
            year: "2025",
            medium: "Porcelain",
            dimensions: '4" long'
          },
          {
            type: 'artwork',
            id: 162,
            imagePath: 'Girl5.jpg',
            title: "Rest",
            year: "2025",
            medium: "Porcelain",
            dimensions: '4" long'
          },
        
          {
            type: 'category',
            title: 'Small Creatures',
            subtitle: 'Various pieces',
            description: 'Miniature life forms in porcelain'
          },
          {
            type: 'artwork',
            id: 163,
            imagePath: 'bells1.jpg',
            title: "Bells",
            year: "1993",
            medium: "Porcelain",
            dimensions: '1.5" tall'
          },
          {
            type: 'artwork',
            id: 164,
            imagePath: 'bells2.jpg',
            title: "Bells",
            year: "1993",
            medium: "Porcelain",
            dimensions: '1.5" tall'
          },
          {
            type: 'artwork',
            id: 165,
            imagePath: 'bells3.jpg',
            title: "Bells",
            year: "1993",
            medium: "Porcelain",
            dimensions: '1.5" tall'
          },
          {
            type: 'artwork',
            id: 166,
            imagePath: 'bells4.jpg',
            title: "Bells",
            year: "1993",
            medium: "Porcelain",
            dimensions: '1.5" tall'
          },
          {
            type: 'artwork',
            id: 167,
            imagePath: 'bells5.jpg',
            title: "Bells",
            year: "1993",
            medium: "Porcelain",
            dimensions: '1.5" tall'
          },
          {
            type: 'artwork',
            id: 168,
            imagePath: 'Bells.mp4',
            mediaType: 'video',
            title: "Bells",
            year: "1993",
            medium: "Porcelain",
            dimensions: '1.5" tall'
          },
          {
            type: 'artwork',
            id: 169,
            imagePath: 'Птеце_Рыб1.jpg',
            title: "Птице Рыб",
            year: "2025",
            medium: "Porcelain",
            dimensions: '4" long'
          },
          {
            type: 'artwork',
            id: 170,
            imagePath: 'Птеце_Рыб2.jpg',
            title: "Птице Рыб",
            year: "2025",
            medium: "Porcelain",
            dimensions: '4" long'
          },
          {
            type: 'artwork',
            id: 171,
            imagePath: 'Птеце_Рыб3.jpg',
            title: "Птице Рыб",
            year: "2025",
            medium: "Porcelain",
            dimensions: '4" long'
          },
          {
            type: 'artwork',
            id: 172,
            imagePath: 'Птеце_Рыб5.jpg',
            title: "Птице Рыб",
            year: "2025",
            medium: "Porcelain",
            dimensions: '4" long'
          },
          {
            type: 'artwork',
            id: 173,
            imagePath: 'Snake1.jpg',
            title: "Year of the Snake",
            year: "2025",
            medium: "Porcelain",
            dimensions: '3.5" long'
          },
          {
            type: 'artwork',
            id: 174,
            imagePath: 'Snake2.jpg',
            title: "Year of the Snake",
            year: "2025",
            medium: "Porcelain",
            dimensions: '3.5" long'
          },
          {
            type: 'artwork',
            id: 175,
            imagePath: 'Snake3.jpg',
            title: "Year of the Snake",
            year: "2025",
            medium: "Porcelain",
            dimensions: '3.5" long'
          },
          {
            type: 'artwork',
            id: 176,
            imagePath: 'Snake4.jpg',
            title: "Year of the Snake",
            year: "2025",
            medium: "Porcelain",
            dimensions: '3.5" long'
          },
          {
            type: 'artwork',
            id: 177,
            imagePath: 'Snake5.jpg',
            title: "Year of the Snake",
            year: "2025",
            medium: "Porcelain",
            dimensions: '3.5" long'
          },
          {
            type: 'artwork',
            id: 178,
            imagePath: 'TinyMouse1.jpg',
            title: "Tiny Mouse",
            year: "2025",
            medium: "Porcelain",
            dimensions: '1" long'
          },
          {
            type: 'artwork',
            id: 179,
            imagePath: 'TinyMouse2.jpg',
            title: "Tiny Mouse",
            year: "2025",
            medium: "Porcelain",
            dimensions: '1" long'
          },
          {
            type: 'artwork',
            id: 180,
            imagePath: 'TinyMouse3.jpg',
            title: "Tiny Mouse",
            year: "2025",
            medium: "Porcelain",
            dimensions: '1" long'
          },
          {
            type: 'artwork',
            id: 181,
            imagePath: 'TinyCat1.jpg',
            title: "Tiny Cat",
            year: "2025",
            medium: "Porcelain",
            dimensions: '1.5" long'
          },
          {
            type: 'artwork',
            id: 182,
            imagePath: 'TinyCat2.jpg',
            title: "Tiny Cat",
            year: "2025",
            medium: "Porcelain",
            dimensions: '1.5" long'
          },
          {
            type: 'artwork',
            id: 183,
            imagePath: 'TinyCat3.jpg',
            title: "Tiny Cat",
            year: "2025",
            medium: "Porcelain",
            dimensions: '1.5" long'
          },
        ],
          // PART 3: WEARABLES SECTION - IDs 300-320
        wearable: [
          {
            type: 'category',
            title: 'Porcelain Brooches Series',
            subtitle: '14 pieces',
            description: 'Small-scale tales on wearable porcelain forms.'
          },
          {
            type: 'artwork',
            id: 300,
            imagePath: 'The_Readers_Pause.jpg',
            title: "The Readers Pause",
            year: "1992",
            medium: "Porcelain brooch",
            dimensions: '1.5"'
          },
          {
            type: 'artwork',
            id: 301,
            imagePath: 'CityGirl.jpg',
            title: "City Girl",
            year: "1992",
            medium: "Porcelain brooch",
            dimensions: '1.5"'
          },
          {
            type: 'artwork',
            id: 302,
            imagePath: 'FashionGirl1.jpg',
            title: "Fashion Girl",
            year: "1992",
            medium: "Porcelain brooch",
            dimensions: '1.5"'
          },
          {
            type: 'artwork',
            id: 303,
            imagePath: 'harlequin2.jpg',
            title: "Harlequin II",
            year: "1992",
            medium: "Porcelain brooch",
            dimensions: '1.5"'
          },
          {
            type: 'artwork',
            id: 304,
            imagePath: 'TinyTale1.jpg',
            title: "Tiny Tales 1",
            year: "1992",
            medium: "Porcelain brooch",
            dimensions: '1.5"'
          },
          {
            type: 'artwork',
            id: 305,
            imagePath: 'TinyTale3.jpg',
            title: "Tiny Tales 2",
            year: "1992",
            medium: "Porcelain brooch",
            dimensions: '1.5"'
          },
          {
            type: 'artwork',
            id: 306,
            imagePath: 'TinyTale5.jpg',
            title: "Tiny Tales 3",
            year: "1992",
            medium: "Porcelain brooch",
            dimensions: '1.5"'
          },
          {
            type: 'artwork',
            id: 307,
            imagePath: 'FashionGirl2.jpg',
            title: "Fashion Girl II",
            year: "1992",
            medium: "Porcelain brooch",
            dimensions: '1.5"'
          },
          {
            type: 'artwork',
            id: 308,
            imagePath: 'harlequin3.jpg',
            title: "Harlequin III",
            year: "1992",
            medium: "Porcelain brooch",
            dimensions: '1.5"'
          },
          {
            type: 'artwork',
            id: 309,
            imagePath: 'TinyTale2.jpg',
            title: "Tiny Tales",
            year: "1992",
            medium: "Porcelain brooches",
            dimensions: '1.5"'
          },
          {
            type: 'artwork',
            id: 310,
            imagePath: 'TinyTale8.jpg',
            title: "Tiny Tales",
            year: "1992",
            medium: "Porcelain brooches",
            dimensions: '1.5"'
          },
          {
            type: 'artwork',
            id: 311,
            imagePath: 'TinyTale7.jpg',
            title: "Tiny Tales",
            year: "1992",
            medium: "Porcelain brooches",
            dimensions: '1.5"'
          },
          {
            type: 'artwork',
            id: 312,
            imagePath: 'harlequins.jpg',
            title: "Harlequins",
            year: "1992",
            medium: "Porcelain brooches",
            dimensions: '1.5"'
          },
          {
            type: 'artwork',
            id: 313,
            imagePath: 'Stage.jpg',
            title: "Stage",
            year: "1992",
            medium: "Porcelain brooches",
            dimensions: '1.5"'
          },
        
          {
            type: 'category',
            title: 'Porcelain Magnets Series',
            subtitle: '7 pieces',
            description: 'Miniature sculptures of still lifes, cityscapes, and happy creatures.'
          },
          {
            type: 'artwork',
            id: 314,
            imagePath: 'house_magnets.jpg',
            title: "cityscapes magnets",
            year: "1992",
            medium: "Porcelain",
            dimensions: '3" long'
          },
          {
            type: 'artwork',
            id: 315,
            imagePath: 'fish.jpg',
            title: "Happy fish",
            year: "1992",
            medium: "Porcelain brooch",
            dimensions: '2.5" long'
          },
          {
            type: 'artwork',
            id: 316,
            imagePath: 'PXL_20241009_173504653.jpg',
            title: "Happy fish",
            year: "1992",
            medium: "Porcelain",
            dimensions: '3.5" long'
          },
          {
            type: 'artwork',
            id: 317,
            imagePath: 'PXL_20241009_173451722.jpg',
            title: "Happy fish",
            year: "1992",
            medium: "Porcelain",
            dimensions: '2.5" long'
          },
          {
            type: 'artwork',
            id: 318,
            imagePath: 'PXL_20241009_173400157.jpg',
            title: "Still life",
            year: "1992",
            medium: "Porcelain",
            dimensions: '2.5" long'
          },
          {
            type: 'artwork',
            id: 319,
            imagePath: 'PXL_20241009_173312640.jpg',
            title: "Still life",
            year: "1992",
            medium: "Porcelain",
            dimensions: '2.5" long'
          },
          {
            type: 'artwork',
            id: 320,
            imagePath: 'magnets.mp4',
            mediaType: 'video',
            title: "Still life magnets",
            year: "1992",
            medium: "Porcelain",
            dimensions: '2.5" long'
          },
          {
            type: 'category',
            title: 'Porcelain kitty necklace',
            subtitle: '8 pieces',
            description: 'Cat Pendant'
          },
          {
            type: 'artwork',
            id: 321,
            imagePath: 'Cats2.jpg',
            title: "Cat",
            year: "2025",
            medium: "Porcelain",
            dimensions: '1" long'
          },
          {
            type: 'artwork',
            id: 322,
            imagePath: 'Cats3.jpg',
            title: "Cat",
            year: "2025",
            medium: "Porcelain",
            dimensions: '1" long'
          },
          {
            type: 'artwork',
            id: 323,
            imagePath: 'Cats4.jpg',
            title: "Cat",
            year: "2025",
            medium: "Porcelain",
            dimensions: '1" long'
          },
          {
            type: 'artwork',
            id: 324,
            imagePath: 'Cats5.jpg',
            title: "Cat",
            year: "2025",
            medium: "Porcelain",
            dimensions: '1" long'
          },
          {
            type: 'artwork',
            id: 325,
            imagePath: 'Cats6.jpg',
            title: "Cat",
            year: "2025",
            medium: "Porcelain",
            dimensions: '1" long'
          },
          {
            type: 'artwork',
            id: 326,
            imagePath: 'Cats7.jpg',
            title: "Cat",
            year: "2025",
            medium: "Porcelain",
            dimensions: '1" long'
          },
          {
            type: 'artwork',
            id: 327,
            imagePath: 'Cats8.jpg',
            title: "Cat",
            year: "2025",
            medium: "Porcelain",
            dimensions: '1" long'
          },
          {
            type: 'artwork',
            id: 328,
            imagePath: 'CustomCat.jpg',
            title: "Cat",
            year: "2025",
            medium: "Porcelain",
            dimensions: '1" long'
          },
          {
            type: 'category',
            title: 'Tiny houses',
            subtitle: 'Various pieces',
            description: 'Miniature houses in porcelain'
          },
          {
            type: 'artwork',
            id: 329,
            imagePath: 'houses1.jpg',
            title: "Houses necklace",
            year: "1993/2025",
            medium: "Porcelain",
            dimensions: '1" long'
          },
          {
            type: 'artwork',
            id: 330,
            imagePath: 'houses2.jpg',
            title: "Houses earrings",
            year: "1993/2025",
            medium: "Porcelain",
            dimensions: '1.5" long'
          },
          {
            type: 'artwork',
            id: 331,
            imagePath: 'houses.mp4',
            mediaType: 'video',
            title: "Houses earrings",
            year: "1993/2025",
            medium: "Porcelain",
            dimensions: '1.5" long'
          },
          {
            type: 'category',
            title: 'Stoneware and Porcelain functional pieces',
            subtitle: 'Various pieces',
            description: '',
          },
          {
            type: 'artwork',
            id: 341,
            imagePath: 'fish_tray_2.jpg',
            title: "Fish tray",
            year: "2025",
            medium: "porcelain, nerikomi",
            dimensions: '9"'
          },
          {
            type: 'artwork',
            id: 342,
            imagePath: 'fish_tray_1.jpg',
            title: "Fish tray",
            year: "2025",
            medium: "porcelain, nerikomi",
            dimensions: '9"'
          },
          {
            type: 'artwork',
            id: 336,
            imagePath: 'marbled_tray_1.jpg',
            title: "Marbled tray",
            year: "2025",
            medium: "marbled porcelain",
            dimensions: '9"'
          },
          {
            type: 'artwork',
            id: 337,
            imagePath: 'marbled_tray_2.jpg',
            title: "Marbled tray",
            year: "2025",
            medium: "marbled porcelain",
            dimensions: '9"'
          },
          {
            type: 'artwork',
            id: 338,
            imagePath: 'birdPlate_1.jpg',
            title: "Bird Plate",
            year: "2026",
            medium: "Stoneware",
            dimensions: '9"'
          },
          {
            type: 'artwork',
            id: 339,
            imagePath: 'birdPlate_2.jpg',
            title: "Bird Plate",
            year: "2026",
            medium: "Stoneware",
            dimensions: '9"'
          },
          {
            type: 'artwork',
            id: 340,
            imagePath: 'birdPlate_3.jpg',
            title: "Bird Plate",
            year: "2026",
            medium: "Stoneware",
            dimensions: '9"'
          },
          {
            type: 'artwork',
            id: 350,
            imagePath: 'candleholder_1.jpg',
            title: "Candleholder",
            year: "2026",
            medium: "Stoneware, porcelain",
            dimensions: '4"'
          },
          {
            type: 'artwork',
            id: 351,
            imagePath: 'candleholder_2.jpg',
            title: "Candleholder",
            year: "2026",
            medium: "Stoneware, porcelain",
            dimensions: '4"'
          },
          {
            type: 'artwork',
            id: 352,
            imagePath: 'Folded_vessel_1.jpg',
            title: "Folded vessel",
            year: "2026",
            medium: "Seattle freeze clay",
            dimensions: '4"'
          },
           {
            type: 'artwork',
            id: 353,
            imagePath: 'Folded_vessel_2.jpg',
            title: "Folded vessel",
            year: "2026",
            medium: "Seattle freeze clay",
            dimensions: '4"'
          },
           {
            type: 'artwork',
            id: 354,
            imagePath: 'Folded_vessel_3.jpg',
            title: "Folded vessel",
            year: "2026",
            medium: "Seattle freeze clay",
            dimensions: '4"'
          },
          {
            type: 'artwork',
            id: 355,
            imagePath: 'Folded_vessel_4.jpg',
            title: "Folded vessel",
            year: "2026",
            medium: "Seattle freeze clay",
            dimensions: '4"'
          },
          {
            type: 'artwork',
            id: 356,
            imagePath: 'The_Catch_1.jpg',
            title: "The Catch",
            year: "2026",
            medium: "Seattle freeze clay",
            dimensions: '3"'
          },
          {
            type: 'artwork',
            id: 357,
            imagePath: 'The_Catch_2.jpg',
            title: "The Catch",
            year: "2026",
            medium: "Seattle freeze clay",
            dimensions: '3"'
          },
          {
            type: 'category',
            title: 'Stoneware misc',
            subtitle: 'Various pieces',
            description: 'Playing with stoneware - some to wear, some for the plants',
          },
          {
            type: 'artwork',
            id: 332,
            imagePath: 'stoneware1.jpg',
            title: "",
            year: "2014/2025",
            medium: "stoneware",
            dimensions: '1-2" long'
          },
          {
            type: 'artwork',
            id: 333,
            imagePath: 'stoneware2.jpg',
            title: "",
            year: "2014/2025",
            medium: "stoneware",
            dimensions: '1-2" long'
          },
          {
            type: 'artwork',
            id: 334,
            imagePath: 'stoneware3.jpg',
            title: "",
            year: "2014/2025",
            medium: "stoneware",
            dimensions: '1-2" long'
          },
          {
            type: 'artwork',
            id: 335,
            imagePath: 'stoneware4.jpg',
            title: "",
            year: "2014/2025",
            medium: "stoneware",
            dimensions: '1-2" long'
          },
          {
            type: 'artwork',
            id: 358,
            imagePath: 'February_misc_1.jpg',
            title: "",
            year: "2026",
            medium: "stoneware",
            dimensions: '2" long'
          },
          {
            type: 'artwork',
            id: 359,
            imagePath: 'February_misc_2.jpg',
            title: "",
            year: "2026",
            medium: "stoneware",
            dimensions: '2" long'
          },
          {
            type: 'artwork',
            id: 360,
            imagePath: 'February_misc_4.jpg',
            title: "",
            year: "2026",
            medium: "stoneware",
            dimensions: ''
          },
          {
            type: 'artwork',
            id: 361,
            imagePath: 'February_misc_3.jpg',
            title: "",
            year: "2026",
            medium: "stoneware, Seattle freeze clay",
            dimensions: ''
          },
          
        ]
        };

// Helper function to get all artworks (excluding categories)
export const getAllArtworks = () => {
    return Object.values(portfolioSections)
      .flat()
      .filter(item => item.type === 'artwork' || !item.type);
  };
  
  // Helper function to get artworks by category
  export const getArtworksByCategory = (category) => {
    return portfolioSections[category] || [];
  };
  
  // Helper function to find artwork by ID
  export const findArtworkById = (id) => {
    const allArtworks = getAllArtworks();
    return allArtworks.find(artwork => artwork.id === id);
  };
  
  // Export default
  export default portfolioSections;